import { Modal, ModalContent, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import { FC, PropsWithChildren, useEffect } from 'react'
import { useMobileBackButton, useModalBodyClass } from '../../hooks/useMobileBackButton'
import { TankInfo } from '../../pages/TankInfo'
import { useTankInfoModalStore } from '../../store/tankInfo/useTankInfoModalStore'

export const TankInfoProvider: FC<PropsWithChildren> = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const modalStore = useTankInfoModalStore()

  useEffect(() => {
    modalStore.initialize(onOpen, onClose)
  }, [])

  useEffect(() => {
    modalStore.setIsOpen(isOpen)
  }, [isOpen])

  useMobileBackButton(
    isOpen,
    () => {
      modalStore.close()
      onClose()
    },
    () => {
      window.history.back()
    },
  )

  useModalBodyClass(isOpen)

  return (
    <>
      {modalStore.tankId !== '' ? (
        <Modal
          isOpen={isOpen}
          size={'6xl'}
          scrollBehavior="inside"
          trapFocus={false}
          lockFocusAcrossFrames={false}
          onClose={() => {
            modalStore.close()
            onClose()
          }}
        >
          <ModalOverlay />
          <ModalContent p={'40px'} maxH={{ base: '90vh', md: '95vh' }} h={{ md: 'auto' }}>
            <TankInfo />
          </ModalContent>
        </Modal>
      ) : (
        <></>
      )}
      {children}
    </>
  )
}
